class Specification {
  name: string;
  value: any;

  constructor(props: any) {
    this.name = props.name;
    this.value = props.value;
  }
}

class SubCategory {
  name: string;
  specs: Array<Specification>;

  constructor(props: any) {
    this.name = props.name;
    this.specs = [];

    if (props.specs) {
      this.specs = props.specs.map((s: any) => new Specification(s));
    }
  }
}

class Category {
  name: string;
  subcategories: Array<SubCategory>;

  constructor(props: any) {
    this.name = props.name;
    this.subcategories = [];

    if (props.subcategories) {
      this.subcategories = props.subcategories.map(
        (sc: any) => new SubCategory(sc)
      );
    }
  }
}

export default class Specifications {
  categories: Array<Category>;

  constructor(props: any) {
    this.categories = [];

    if (props.specifications && props.specifications.categories) {
      this.categories = props.specifications.categories.map(
        (c: any) => new Category(c)
      );
    }
  }
}
